'use strict'

export const submitGuard = (() => {
    const OPT_IN_ATTRIBUTE = 'data-prevent-double-submit'
    const DEFAULT_LABEL = 'Submitting…'

    const lock = (button, label) => {
        if (button.disabled) return
        button.dataset.submitGuardOriginal = button.textContent
        button.textContent = label
        button.setAttribute('aria-busy', 'true')
        button.disabled = true
    }

    const unlock = (button) => {
        const original = button.dataset.submitGuardOriginal
        if (original === undefined) return
        button.textContent = original
        delete button.dataset.submitGuardOriginal
        button.removeAttribute('aria-busy')
        button.disabled = false
    }

    const onSubmit = (event) => {
        const form = event.currentTarget
        const label = form.getAttribute(OPT_IN_ATTRIBUTE) || DEFAULT_LABEL
        form.querySelectorAll('button[type="submit"]').forEach(button => lock(button, label))
    }

    const init = () => {
        document.querySelectorAll(`[${OPT_IN_ATTRIBUTE}]`).forEach(form => {
            form.addEventListener('submit', onSubmit)
        })

        // Restore on bfcache back/forward navigation so the button isn't permanently disabled.
        window.addEventListener('pageshow', (event) => {
            if (!event.persisted) return
            document.querySelectorAll(`[${OPT_IN_ATTRIBUTE}] button[type="submit"]`).forEach(unlock)
        })
    }

    return { init }
})()
